// extracted by mini-css-extract-plugin
export default {"pmsColumn":"AssociatedPlan_pmsColumn__0ej4d"};